import styled, { CSSObject } from '@emotion/styled';
import { rgba } from 'polished';
import { ReactNode } from 'react';
import * as React from 'react';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverOpacity } from '@/utility/theme/animation';

type ButtonProps = {
  active: boolean;
  disabled?: boolean;
  onClick?: () => void;
};

export const Tab = styled.button((props: ButtonProps) =>
  mq({
    flex: '1',
    color: props.disabled
      ? rgba(defaultTheme.color.secondary, 0.3)
      : defaultTheme.text.default,
    textAlign: 'center',
    border: 'none',
    borderRadius: defaultTheme.border.radius.xs,
    boxShadow: props.active
      ? `0px 0px 4px ${defaultTheme.color.grayScale.medium}`
      : '',
    fontSize: defaultTheme.font.size.s,
    fontWeight: props.active ? 'bold' : 'inherit',
    backgroundColor: props.active
      ? defaultTheme.background.white
      : defaultTheme.background.mediumLightGray,
    padding: `${defaultTheme.spacing.l} 0`,
    ...(props.active ? {} : hoverOpacity),
  }),
);

export const Tabs = styled.div((props: { styles?: CSSObject }) =>
  mq({
    display: ['grid', 'grid', 'flex', 'flex'],
    gridTemplateColumns: 'repeat(2, 1fr)',
    padding: defaultTheme.spacing.xs,
    border: `1px solid ${defaultTheme.border.color.mediumLightGray}`,
    borderRadius: defaultTheme.border.radius.s,
    backgroundColor: `${defaultTheme.background.mediumLightGray}`,
    ...props.styles,
  }),
);

const TabButton: React.FC<ButtonProps & { children: ReactNode }> = ({
  children,
  active,
  disabled,
  onClick,
}) => {
  const handleOnClick = () => {
    if (!disabled && onClick) {
      onClick();
    }
  };

  return (
    <Tab
      active={active}
      type="button"
      disabled={disabled}
      onClick={handleOnClick}
    >
      {children}
    </Tab>
  );
};

export default TabButton;
